import { render, staticRenderFns } from "./ModalDetailsStatusPolicy.vue?vue&type=template&id=60c4e621"
import script from "./ModalDetailsStatusPolicy.vue?vue&type=script&lang=js"
export * from "./ModalDetailsStatusPolicy.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailsStatusPolicy.vue?vue&type=style&index=0&id=60c4e621&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports